import { render, staticRenderFns } from "./ColorIcon.vue?vue&type=template&id=63e5f611"
import script from "./ColorIcon.vue?vue&type=script&lang=js"
export * from "./ColorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports